/* eslint-disable react/jsx-props-no-spreading */
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {useEffect, useState} from 'react';
import {checkPermission, formatDateWithTime, formatMoney} from 'utils/utils';
import {apiStatus, defaultpageCount, integrationVendors, permissionKeys, routePaths, sortByTypeType} from 'utils/constants';
import {useSelector} from 'react-redux';
import {locationSelector, orgSelector, userSelector} from 'redux/selectors';
import useUser from 'hooks/useUser';
import ButtonBack from 'components/button/buttonBack';
import Buttons from 'components/button/Buttons';
import {Label, Table, TextInput, Tooltip} from 'flowbite-react';
import {createPurchaseOrder, getPurchaseOrderById, updatePurchaseOrderById} from 'api/purchaseOrderApi';
import { getOrganizationIntegrationConfig } from 'api/organizationApi';
import {getItemById, getItemsByCategory, getItemsByFilter} from 'api/itemApi';
import EmptyState from 'components/commonComponent/emptyState';
import {v4 as uuidv4} from 'uuid';
import {purchaseOrderItemType} from 'utils/proptypes';
import MultiSelect from 'components/select/index';
import {cloneDeep, concat, isEmpty, orderBy} from 'lodash';
import GroupButtonWithIcons from 'components/button/buttonGroupWithIcons';
import {HiOutlineExclamationCircle, HiOutlineTrash} from 'react-icons/hi';
import {toast} from 'react-toastify';
import './purchaseOrder.scss';
import CreateItemByCategoryModal from 'components/modal/purchaseOrderModal/createItemByCategoryModal';
import {initOrder} from 'utils/initData';
import Status from 'components/commonComponent/Status';
import ReviewBy from "../../components/commonComponent/reviewBy";
import axios from 'axios';
import urls from 'api/urls';
import {getLocationById} from 'api/locationApi';
import SpinnerComponent from 'components/spinner';
import StatisticsSaleModal from 'components/modal/purchaseOrderModal/statisticsSaleModal';
import {getStockByItemAndLocation, statisticsSaleItem} from 'api/stockApi';
import Sort from 'components/table/sort';
import MlvedaErrorModal from 'components/modal/purchaseOrderModal/mlvedaErrorModal';

type orderN2GProps = {
    id?: string,
    order: any
};

const PurchaseOrderReview = (props: any) => {
    const {type} = props;
    const {WRITE_PURCHASE_ORDER, PLATFORM_ADMIN} = permissionKeys;
    const location = useLocation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const params: any = useParams();
    const [data, setData] = useState([]);
    const [itemTypeOptions, setItemTypeOptions] = useState([{label: '...', value: null}]);
    const {userInfo} = useSelector(userSelector);
    const {organizationId} = useSelector(orgSelector);
    const {locationId} = useSelector(locationSelector);
    const { handleSetLocationTookie } = useUser();
    const {fetchCurrentUser} = useUser();
    const [searchValue, setSearchValue] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(defaultpageCount);
    const [totalEntities, setTotalEntities] = useState(0);
    const [t] = useTranslation();
    const [sortBy, setSortBy] = useState('');
    const [sortByType, setSortByType] = useState('');
    const isWriteOrg = checkPermission(userInfo, props.type, [WRITE_PURCHASE_ORDER], organizationId);
    const itemEmpty = require('../../assets/image/svg/Emptys.svg').default || '';
    const [openModal, setOpenModal] = useState(false);
    const [openModalStatistics, setOpenModalStatistics] = useState(false);
    const [category, setCategory] = useState([]);
    const [targetPurchaseOrder, setTargetPurchaseOrder] = useState(initOrder);
    const [dataChart, setDataChart] = useState<any>(null);
    const [itemNameChart, setItemNameChart] = useState('');
    const [errorsN2G, setErrorsN2G] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaveDraft, setIsSaveDraft] = useState(false);
    const [orderTotal, setOrderTotal] = useState<number>(0);
    const [totalItem, setTotalItem] = useState<number>(0);
    const [openMlvedaErrorModal, setOpenMlvedaErrorModal] = useState(false);
    const [mlvedaError, setMlvedaError] = useState('');
    const pageCountDefault = 1000;

    const { data: n2gIntegrationData } = useQuery(
        ['getOrganizationIntegrationConfig', organizationId, integrationVendors.N2G_MLVEDA],
        () => getOrganizationIntegrationConfig(organizationId, integrationVendors.N2G_MLVEDA),
        { enabled: !!organizationId },
    );

    const n2gBaseUrl = n2gIntegrationData?.data?.siteUrl || process.env.REACT_APP_N2G_MLVEDA_API_URL || '';
    const n2gValidateUrl = n2gBaseUrl ? `${n2gBaseUrl}/order/validateOrder/` : urls.purchaseOrder.validateOrderN2G;
    const n2gCreateUrl = n2gBaseUrl ? `${n2gBaseUrl}/order/` : urls.purchaseOrder.creationOrderN2G;

    useEffect(() => {
        if (params.id !== '') {
            setIsLoading(true);
            getPurchaseOrderById(params?.id).then((res: any) => {
                setTargetPurchaseOrder(res.data);
                setOrderTotal(res.data?.orderTotal || 0);
                setTotalItem(res.data?.purchaseOrderItems?.length);
                if (data?.length > 0 && data?.length !==  res.data?.purchaseOrderItems?.length) {
                    handleSortData();
                } else {
                    setData(res.data?.purchaseOrderItems?.map((item: any) => {
                        return {id: item.id, itemId: item.itemId, item: item.item, orderCount: item.quantityOrdered, quantityReceived: item.quantityReceived, quantityOnHand: item.quantityOnHand, unitSoldLast7: item.unitSoldLast7,sixWeekAvg: item.sixWeekAvg}
                    }));
                    handleSortData();
                }
                if (res.data?.status === 'Draft' || res.data?.status === 'Requested') {
                    //validate data to n2g
                    getLocationAndConvertLocationN2G(locationId).then((resLocation: any) => { 
                        const validateData: orderN2GProps = {
                            order: {
                                customer: getCustomerN2GWhenLoading(res.data),
                                location: resLocation,
                                items: convertItemToItemN2G(res.data?.purchaseOrderItems)
                            }
                        };
                        if (validateData.order?.location) {
                            const url = n2gValidateUrl;
                            axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                                .then(response => {
                                    setErrorsN2G(null);
                                    setIsLoading(false);
                                })
                                .catch(error => {
                                    if (error?.response?.data?.errors || error?.response?.data?.location) {
                                        const errorsItems: any = [];
                                        for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                            const element = error.response.data?.errors[index];
                                            for (let index = 0; index < element.errors?.length; index++) {
                                                const elementMsg = element.errors[index];
                                                elementMsg.sku = element.sku;
                                                if (element.quantityAvailable !== undefined) {
                                                    elementMsg.quantityAvailable = element.quantityAvailable;
                                                }
                                                errorsItems.push(elementMsg);
                                            }
                                        }
                                        const errorsLocation = error.response.data?.location?.errors;
                                        const errorsCustomer = error.response.data?.customer?.errors;
                                        const errorsList: any = {
                                            location: errorsLocation,
                                            items: errorsItems,
                                            customer: errorsCustomer
                                        }
                                        setErrorsN2G(errorsList);
                                        setIsLoading(false);
                                    }
                                });
                        }
                    });
                } else {
                    setIsLoading(false);
                }
            });
        } else {
            if (data?.length > 0) {
                handleSortData();
            } else {
                setData([]);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params?.id, locationId, sortBy, sortByType]);

    useEffect(() => {
        const setLocationSelect = async (idLocation: string) => {
            await handleSetLocationTookie(idLocation, organizationId);
        }
        if (targetPurchaseOrder && targetPurchaseOrder.locationId !== locationId) {
            const timeoutId = setTimeout(() => {
                setLocationSelect(targetPurchaseOrder?.locationId);
            }, 1000);
            
            return () => {
                clearTimeout(timeoutId);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[targetPurchaseOrder])

    const handleSortData = () => {
        if (sortBy && sortByType) {
            const sortType = sortByType === sortByTypeType.ASC ? 'asc' : 'desc';
            let sortedList: any = [];
            switch (sortBy) {
                case 'itemName':
                    sortedList = orderBy(data, ['item.name'], sortType);
                    break;
                case 'itemSku':
                    sortedList = orderBy(data, ['item.sku'], sortType);
                    break;
                case 'quantityOrdered':
                    sortedList = orderBy(data, ['orderCount'], sortType);
                    break;
                case 'itemCaseCost':
                    sortedList = orderBy(data, ['item.caseCost'], sortType);
                    break;
            }
            setData(sortedList);
        }
    }

    const handleHeaderSort = (field: string) => {
        setSortBy(field);
        let type = '';
        if (field !== sortBy) {
            type = sortByTypeType.ASC;
        } else if (sortByType === sortByTypeType.ASC) {
            type = sortByTypeType.DESC;
        } else {
            setSortBy(type);
        }
        setSortByType(type);
    };

    useEffect(() => {
        if (category.length > 0) {
            let ids: string = '';
            for (let index = 0; index < category.length; index++) {
                const id = category[index];
                if (ids === '') {
                    ids = id;
                } else {
                    ids = `${ids},${id}`;
                }
            }
            getItemsByCategory({categoryIds: ids, locationId}).then((res: any) => {
                if (res.data.totalEntities > 0) {
                    if (data && data?.length > 0) {
                        const mergedItems = [...data,...res.data.entities.map((item: any) => {
                            return {id: uuidv4(), itemId: item.id, item: item, orderCount: 1, quantityOnHand: item.quantityOnHand, unitSoldLast7: item.unitSoldLast7, sixWeekAvg: item.sixWeekAvg};
                        })];
                        const uniqueItems = mergedItems.reduce((acc, item) => {
                            if (!acc.some((existingItem: any) => existingItem.itemId === item.itemId)) {
                              acc.push(item);
                            }
                            return acc;
                          }, []).filter((f: any) => f.item !== null);
                          setData(uniqueItems);
                          validateOrderN2G(locationId, uniqueItems);
                          calculationTotal(uniqueItems);
                    } else {
                        setData(
                            res.data.entities.map((item: any) => {
                                return {id: uuidv4(), itemId: item.id, item: item, orderCount: 1, quantityOnHand: item.quantityOnHand, unitSoldLast7: item.unitSoldLast7, sixWeekAvg: item.sixWeekAvg};
                            }),
                        );
                        validateOrderN2G(locationId, data);
                        calculationTotal(res.data.entities.map((item: any) => {
                            return {id: uuidv4(), itemId: item.id, item: item, orderCount: 1, quantityOnHand: item.quantityOnHand, unitSoldLast7: item.unitSoldLast7, sixWeekAvg: item.sixWeekAvg};
                        }));
                    }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category]);

    const validateOrderN2G = (locationId: string, request: any) => {
        //validate data to n2g
        getLocationAndConvertLocationN2G(locationId).then((resLocation: any) => { 
            const validateData: orderN2GProps = {
                order: {
                    customer: getCustomerN2G(),
                    location: resLocation,
                    items: convertItemToItemN2G(request)
                }
            };
            if (validateData.order?.location) {
                const url = n2gValidateUrl;
                axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                    .then(response => {
                        setErrorsN2G(null);
                    })
                    .catch(error => {
                        if (error?.response?.data?.errors || error?.response?.data?.location) {
                            const errorsItems: any = [];
                            for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                const element = error.response.data?.errors[index];
                                for (let index = 0; index < element.errors?.length; index++) {
                                    const elementMsg = element.errors[index];
                                    elementMsg.sku = element.sku;
                                    if (element.quantityAvailable !== undefined) {
                                        elementMsg.quantityAvailable = element.quantityAvailable;
                                    }
                                    errorsItems.push(elementMsg);
                                }
                            }
                            const errorsLocation = error.response.data?.location?.errors;
                            const errorsCustomer = error.response.data?.customer?.errors;
                            const errorsList: any = {
                                location: errorsLocation,
                                items: errorsItems,
                                customer: errorsCustomer
                            }
                            setErrorsN2G(errorsList);
                        }
                    });
            }
        });
    }

    const calculationTotal = (requestData: any) => {
        let sum = 0;
        for (let index = 0; index < requestData?.length; index++) {
            const element: any = requestData[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(requestData?.length);
    }

    useEffect(() => {
        if (errorsN2G?.location && errorsN2G?.location?.length > 0) {
            toast.error(`Location Error: ${buildErrorMessageN2G(errorsN2G.location)}`);
        }
        if (errorsN2G?.customer && errorsN2G?.customer?.length > 0) {
            toast.error(`Customer Error: ${buildErrorMessageN2G(errorsN2G.customer)}`);
        }
        // eslint-disable-next-line
    }, [errorsN2G]);

    const fetchItems = async () => {
        if (!params?.id) return;
    
        let listTemps = [];
    
        try {
          const filterParams = {
            limit: pageCountDefault,
            sortByType: sortByTypeType.DESC,
            organizationId,
            locationId,
            isActive: true, // Always filter to active items only for purchase orders
          };
    
          const res = await getItemsByFilter({ ...filterParams, page: 0 });
          const totalCount = res?.data?.totalEntities || 0;
    
          if (totalCount === 0) {
            setItemTypeOptions([]);
            return;
          }
    
          listTemps = res?.data?.entities || [];
    
          const pageBreak = Math.ceil(totalCount / pageCountDefault);
    
          for (let index = 1; index < pageBreak; index++) {
            const resPage = await getItemsByFilter({ ...filterParams, page: index });
            listTemps = [...listTemps, ...(resPage?.data?.entities || [])];
          }
    
          const newOptions = listTemps.map((item: any) => ({
            label: item.name,
            value: { id: item.id, upcs: item.upcs },
          }));
    
          setItemTypeOptions(newOptions);
        } catch (error) {
          console.error('Error fetching items:', error);
          setItemTypeOptions([]);
        } finally {
          
        }
      };

    useEffect(() => {
        fetchItems();

        // eslint-disable-next-line
    }, [params?.id]);

    const handleUpdatePurchaseOrder = async (items: any, status: string) => {
        let check = true;
        const payload: any = {
            name: targetPurchaseOrder.name,
            locationId: targetPurchaseOrder?.locationId,
            location: {id: targetPurchaseOrder?.locationId},
            status: status,
            requestedOn: targetPurchaseOrder.requestedOn ? targetPurchaseOrder.requestedOn : new Date(),
            requestedBy: targetPurchaseOrder.requestedBy ? targetPurchaseOrder.requestedBy : userInfo.id,
            requestedUser: {id: targetPurchaseOrder.requestedBy ? targetPurchaseOrder.requestedBy : userInfo.id},
            reviewedBy: userInfo.id,
            reviewedUser: {id: userInfo.id},
            purchaseOrderItems: items.map((i: any) => {
                return {
                    id: i.id,
                    itemId: i.itemId,
                    item: i.item,
                    quantityOrdered: i.orderCount,
                    quantityReceived: 0
                }
            })
        }
        for (let index = 0; index < items.length; index++) {
            const rowItem: any = items[index];
            if (rowItem) {
                if (rowItem.itemId === '') {
                    check = false;
                } else {
                    if (rowItem.orderCount === 0) {
                        check = false;
                    }
                }
            }
        }

        if (errorsN2G) {
            if (errorsN2G.items && errorsN2G.items.length > 0) {
                check = false;
            }

            if (errorsN2G.location && errorsN2G.location.length > 0) {
                check = false;
            }

            if (errorsN2G.customer && errorsN2G.customer.length > 0) {
                check = false;
            }
        }

        if (check === true) {
            setIsLoading(true);
            if (status === 'Ordered') {
                payload.orderedOn = new Date();
                const checkItemActive = items?.filter((x: any) => x.item?.isActive === false);
                if (checkItemActive && checkItemActive?.length > 0) {
                    const message: string = t('orderPage.errorInactiveItemOder');
                    toast.error(message);
                    setIsLoading(false);
                } else {
                    const checkMaxOrder = items?.filter((x: any) => x.item?.maxOrderQuantity && x.orderCount > x.item?.maxOrderQuantity);
                    if (checkMaxOrder && checkMaxOrder?.length > 0) {
                        const message: string = t('orderPage.updateCasesField');
                        toast.error(message);
                        setIsLoading(false);
                    } else {
                        //validate data to n2g
                        getLocationAndConvertLocationN2G(locationId).then((resLocation: any) => { 
                            const validateData: orderN2GProps = {
                                order: {
                                    customer: getCustomerN2G(),
                                    location: resLocation,
                                    items: convertItemToItemN2G(items)
                                }
                            };
                            if (validateData.order?.location) {
                                const url = n2gValidateUrl;
                                axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                                    .then(async response => {
                                        //submit po to n2g
                                        const creationData: orderN2GProps = {
                                            id: targetPurchaseOrder?.id,
                                            order: {
                                                customer: getCustomerN2G(),
                                                location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                                                items: convertItemToItemN2G(items)
                                            }
                                        };
                        
                                        const url = n2gCreateUrl;
                                        axios.post(url, creationData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                                            .then(async response => {
                                                let orderId = 0;
                                                if (response?.data?.orderID) {
                                                    orderId = response?.data?.orderID;
                                                }
                                                payload.orderN2GId = orderId.toString();
                                                await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                                                setIsLoading(false);
                                                const message: string = t('orderPage.editSuccess');
                                                toast.success(message);
                                                fetchCurrentUser();
                                                navigate(-1);
                                            })
                                            .catch(async error => {
                                                //check Conflict order
                                                if (error?.response?.status === 409) {
                                                    let orderId = 0;
                                                    if (error?.response?.data?.orderData?.order_number) {
                                                        orderId = error?.response?.data?.orderData?.order_number;
                                                    }
                                                    payload.orderN2GId = orderId.toString();
                                                    const orderItems: any = [];
                                                    for (let index = 0; index < error?.response?.data?.orderData?.line_items?.length; index++) {
                                                        const orderItem = error?.response?.data?.orderData?.line_items[index];
                                                        const findItem = payload.purchaseOrderItems?.find((i: any) => i.item?.sku === orderItem.sku);
                                                        if (findItem) {
                                                            findItem.quantityOrdered = orderItem.quantity;
                                                            orderItems.push(findItem);
                                                        }
                                                    }
                                                    payload.purchaseOrderItems = orderItems;
                                                    await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                                                    setIsLoading(false);
                                                    const message: string = t('orderPage.editSuccess');
                                                    toast.success(message);
                                                    fetchCurrentUser();
                                                    navigate(-1);
                                                } else {
                                                    if (error?.response?.data) {
                                                        const message = error?.response?.data?.length > 0 ? error?.response?.data[0].message : t('orderPage.editFail');
                                                        toast.error(message);
                                                    }
                                                    if (error?.message) {
                                                        toast.error(`${error?.message} from ${url}`);
                                                    }
                                                    setIsLoading(false);
                                                    const err = {
                                                        request: creationData,
                                                        response: error?.response?.data
                                                    }
                                                    setMlvedaError(JSON.stringify(err));
                                                    setOpenMlvedaErrorModal(!openMlvedaErrorModal);
                                                }
                                            });
                                    })
                                    .catch(error => {
                                        if (error?.response?.data?.errors || error?.response?.data?.location) {
                                            const errorsItems: any = [];
                                            for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                                const element = error.response.data?.errors[index];
                                                for (let index = 0; index < element.errors?.length; index++) {
                                                    const elementMsg = element.errors[index];
                                                    elementMsg.sku = element.sku;
                                                    if (element.quantityAvailable !== undefined) {
                                                        elementMsg.quantityAvailable = element.quantityAvailable;
                                                    }
                                                    errorsItems.push(elementMsg);
                                                }
                                            }
                                            const errorsLocation = error.response.data?.location?.errors;
                                            const errorsCustomer = error.response.data?.customer?.errors;
                                            const errorsList: any = {
                                                location: errorsLocation,
                                                items: errorsItems,
                                                customer: errorsCustomer
                                            }
                                            setErrorsN2G(errorsList);
                                            setIsLoading(false);
                                        }
                                    });
                            }
                        });
                    }
                }
            } else {
                payload.rejectedOn = status === 'Rejected' ? new Date() : null;
                const checkItemActive = items?.filter((x: any) => x.item?.isActive === false);
                if (checkItemActive && checkItemActive?.length > 0) {
                    const message: string = t('orderPage.errorInactiveItemOder');
                    toast.error(message);
                } else {
                    const checkMaxOrder = items?.filter((x: any) => x.item?.maxOrderQuantity && x.orderCount > x.item?.maxOrderQuantity);
                    if (checkMaxOrder && checkMaxOrder?.length > 0) {
                        const message: string = t('orderPage.updateCasesField')
                        toast.error(message);
                        setIsLoading(false);
                    } else {
                        await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                        const message: string = t('orderPage.editSuccess');
                        toast.success(message);
                        fetchCurrentUser();
                        setIsLoading(false);
                        navigate(-1);
                    }
                }
            }
        } else {
            if (status === 'Rejected') {
                payload.rejectedOn = new Date();
                await updatePurchaseOrderById(targetPurchaseOrder.id, payload);
                const message: string = t('orderPage.editSuccess');
                toast.success(message);
                fetchCurrentUser();
                setIsLoading(false);
                navigate(-1);
            } else {
                if (errorsN2G?.location && errorsN2G?.location?.length > 0) {
                    toast.error(`Location Error: ${buildErrorMessageN2G(errorsN2G.location)}`);
                }
                if (errorsN2G?.customer && errorsN2G?.customer?.length > 0) {
                    toast.error(`Location Error: ${buildErrorMessageN2G(errorsN2G.customer)}`);
                }
                toast.error(`${t('stockPage.requiredFieldMessage')}`);
                setIsLoading(false);
            }
        }
    };

    const handleSaveDraft = async (items: any) => {
        setIsSaveDraft(true);
        let payload: any;
            if (targetPurchaseOrder.id !== '') {
                payload = {
                    name: targetPurchaseOrder.name,
                    locationId: locationId,
                    location: {id: locationId},
                    status: 'Draft',
                    purchaseOrderItems: items.map((i: any) => {
                        return {
                            id: i.id,
                            itemId: i.itemId,
                            item: i.item,
                            quantityOrdered: i.orderCount,
                            quantityReceived: 0
                        }
                    })
                }
            } else {
                payload = {
                    name: `Order By ${userInfo.firstName} ${userInfo.lastName}`,
                    locationId: locationId,
                    location: {id: locationId},
                    status: 'Draft',
                    purchaseOrderItems: items.map((i: any) => {
                        return {itemId: i.itemId, item: i.item, quantityOrdered: i.orderCount, quantityReceived: 0};
                    }),
                };
            }

            const res = targetPurchaseOrder.id !== '' ? await updatePurchaseOrderById(targetPurchaseOrder.id, payload) : await createPurchaseOrder(payload);
            if (res.status >= apiStatus.SUCCESS) {
                const message: string = targetPurchaseOrder.id !== '' ? t('orderPage.editSuccess') : t('orderPage.saveSuccess');
                toast.success(message);
                fetchCurrentUser();
                setIsSaveDraft(false);
                navigate(-1);
            } else {
                toast.error(res.statusText);
                fetchCurrentUser();
                setIsSaveDraft(false);
            }
    };

    const handleAddRow = (item: any) => {
        const newRow: purchaseOrderItemType = {
            // Initialize the properties of the new row here
            // For example:
            id: uuidv4(),
            itemId: '',
            item: null,
            orderCount: 1,
            quantityReceived: 0,
            quantityOnHand: 0,
            unitSoldLast7: 0,
            sixWeekAvg:  0
        };
        const newData: any = concat(data, newRow);
        setData(newData);
    };

    const handleAddItemByCategory = () => {
        setOpenModal(!openModal);
    };

    const handleDuplicatePO = async (payload: any) => {
        if (payload?.purchaseOrderItems?.length > 0) {
            setIsLoading(true);
            const request = {
                name: `Order By ${userInfo.firstName} ${userInfo.lastName} - Duplicate`,
                locationId: payload.locationId,
                location: {id: payload.locationId},
                status: 'Draft',
                purchaseOrderItems: payload?.purchaseOrderItems?.map((i: any) => {
                    return {itemId: i.itemId, item: i.item, quantityOrdered: i.quantityOrdered, quantityReceived: 0};
                }),
            };

            const res = await createPurchaseOrder(request);
            if (res.status >= apiStatus.SUCCESS) {
                setIsLoading(false);
                const message: string = t('orderPage.duplicateSuccess');
                toast.success(message);
                navigate(`${routePaths.PURCHASE_ORDER_DETAIL}/${res.data?.id}`);
            } else {
                setIsLoading(false);
                toast.error(`${t('orderPage.duplicateFail')}`);
            }
        }
    }

    const handleRemoveAllInvalid = async () => {
        if (errorsN2G) {
            if (data && data.length > 0) {
                const listContentClone = cloneDeep(data);
                const validateData: orderN2GProps = {
                    order: {
                        customer: getCustomerN2G(),
                        location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                        items: convertItemToItemN2G(listContentClone)
                    }
                };
                if (validateData.order?.location) {
                    const url = n2gValidateUrl;
                    await axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                        .then(response => {
                            setErrorsN2G(null);
                            removeInActiveItem();
                        })
                        .catch(error => {
                            if (error?.response?.data?.errors || error?.response?.data?.location) {
                                const errorsItems: any = [];
                                for (let index = 0; index < error.response.data?.errors?.length; index++) {
                                    const element = error.response.data?.errors[index];
                                    for (let index = 0; index < element.errors?.length; index++) {
                                        const elementMsg = element.errors[index];
                                        elementMsg.sku = element.sku;
                                        if (element.quantityAvailable !== undefined) {
                                            elementMsg.quantityAvailable = element.quantityAvailable;
                                        }
                                        errorsItems.push(elementMsg);
                                    }
                                }
                                const errorsLocation = error.response.data?.location?.errors;
                                const errorsCustomer = error.response.data?.customer?.errors;
                                const errorsList: any = {
                                    location: errorsLocation,
                                    items: errorsItems,
                                    customer: errorsCustomer
                                }
                                const skuItems: any = errorsItems?.map((x: any) => x.sku);
                                removeItemsBy('item.sku', skuItems);
                                setErrorsN2G(null);
                            }
                        });
                }
            }
        } else {
            removeInActiveItem();
        }
    };

    const addRowFunc = () => {
        let check = true;
        for (let index = 0; index < data.length; index++) {
            const rowItem: any = data[index];
            if (rowItem) {
                if (rowItem.itemId === '') {
                    check = false;
                } else {
                    if (rowItem.orderCount === 0) {
                        check = false;
                    }
                }
            }
        }

        if (check === false) {
            toast.error(`${t('stockPage.requiredFieldMessage')}`);
        } else {
            const newRow: purchaseOrderItemType = {
                // Initialize the properties of the new row here
                // For example:
                id: uuidv4(),
                itemId: '',
                item: null,
                orderCount: 1,
                quantityReceived: 0,
                quantityOnHand: 0,
                unitSoldLast7: 0,
                sixWeekAvg:  0
            };
            const newData: any = concat(data, newRow);
            setData(newData);
        }
    };

    const handleDeleteRow = (id: string, sku: string) => {
        const newData = data?.filter((d: any) => d.id !== id);
        setData(newData);
        let sum = 0;
        for (let index = 0; index < newData.length; index++) {
            const element: any = newData[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(newData?.length);
        const newItemsErrorsN2G = errorsN2G?.items?.filter((e: any) => e.sku !== sku);
        const newErrorsN2G = {
            location: errorsN2G?.location,
            items: newItemsErrorsN2G
        }
        setErrorsN2G(newErrorsN2G);
    };

    const handleStatictisItem = async (id: string, name: string) => {
        const res = await statisticsSaleItem(id, targetPurchaseOrder?.locationId, 28);
        if (res.data) {
            setDataChart(res.data);
        }
        setItemNameChart(name);
        setOpenModalStatistics(!openModalStatistics);
    };

    const handleChangeItem = async (id: string, option: any, field: any) => {
        const listContentClone = cloneDeep(data);
        const findContent: any = listContentClone?.find((item: any) => item.id === id);
        findContent[field] = option ? option.value?.id : '';
        const res = await getItemById(option ? option.value?.id : '');
        if (res.data) {
            findContent['item'] = res.data;
            findContent['orderCount'] = 1;
        }
        const resStock = await getStockByItemAndLocation(locationId, option ? option.value?.id : '');
        if (resStock) {
            findContent["quantityOnHand"] = resStock.data?.quantityOnHand;
        }
        const resSales7 = await statisticsSaleItem(option ? option.value?.id : '', locationId, 7);
        if (resSales7) {
            findContent["unitSoldLast7"] = resSales7.data?.count;
        }
        const resSales6w = await statisticsSaleItem(option ? option.value?.id : '', locationId, 42);
        if (resSales6w) {
            findContent["sixWeekAvg"] = resSales6w.data?.count;
        }
        setData(listContentClone);
        let sum = 0;
        for (let index = 0; index < listContentClone.length; index++) {
            const element: any = listContentClone[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(listContentClone?.length);

        const validateData: orderN2GProps = {
            order: {
                customer: getCustomerN2G(),
                location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                items: convertItemToItemN2G(listContentClone)
            }
        };
        if (validateData.order?.location) {
            const url = n2gValidateUrl;
            axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                .then(response => {
                    setErrorsN2G(null);
                })
                .catch(error => {
                    if (error?.response?.data?.errors || error?.response?.data?.location) {
                        const errorsItems: any = [];
                        for (let index = 0; index < error.response.data?.errors?.length; index++) {
                            const element = error.response.data?.errors[index];
                            for (let index = 0; index < element.errors?.length; index++) {
                                const elementMsg = element.errors[index];
                                elementMsg.sku = element.sku;
                                if (element.quantityAvailable !== undefined) {
                                    elementMsg.quantityAvailable = element.quantityAvailable;
                                }
                                errorsItems.push(elementMsg);
                            }
                        }
                        const errorsLocation = error.response.data?.location?.errors;
                        const errorsCustomer = error.response.data?.customer?.errors;
                        const errorsList: any = {
                            location: errorsLocation,
                            items: errorsItems,
                            customer: errorsCustomer
                        }
                        setErrorsN2G(errorsList);
                    }
                });
        }
    };

    const handleChangeContentOverview = async (id: string, value: any, field: any) => {
        const listContentClone = cloneDeep(data);
        const findContent: any = listContentClone?.find((item: any) => item.id === id);
        if (field === 'orderCount') {
            const item = findContent['item'];
            findContent[field] = !isEmpty(value) ? parseInt(value) : 0;
        }
        setData(listContentClone);
        let sum = 0;
        for (let index = 0; index < listContentClone.length; index++) {
            const element: any = listContentClone[index];
            sum = sum + ((element.orderCount || 0) * (element.item?.caseCost || 0));
        }
        setOrderTotal(sum);
        setTotalItem(listContentClone?.length);

        const validateData: orderN2GProps = {
            order: {
                customer: getCustomerN2G(),
                location: await getLocationAndConvertLocationN2G(targetPurchaseOrder?.locationId),
                items: convertItemToItemN2G(listContentClone)
            }
        };
        if (validateData.order?.location) {
            const url = n2gValidateUrl;
            axios.post(url, validateData, {headers: {'Access-Control-Allow-Origin': url, 'Accept': '*/*'}})
                .then(response => {
                    setErrorsN2G(null);
                })
                .catch(error => {
                    if (error?.response?.data?.errors || error?.response?.data?.location) {
                        const errorsItems: any = [];
                        for (let index = 0; index < error.response.data?.errors?.length; index++) {
                            const element = error.response.data?.errors[index];
                            for (let index = 0; index < element.errors?.length; index++) {
                                const elementMsg = element.errors[index];
                                elementMsg.sku = element.sku;
                                if (element.quantityAvailable !== undefined) {
                                    elementMsg.quantityAvailable = element.quantityAvailable;
                                }
                                errorsItems.push(elementMsg);
                            }
                        }
                        const errorsLocation = error.response.data?.location?.errors;
                        const errorsCustomer = error.response.data?.customer?.errors;
                        const errorsList: any = {
                            location: errorsLocation,
                            items: errorsItems,
                            customer: errorsCustomer
                        }
                        setErrorsN2G(errorsList);
                    }
                });
        }
    };

    const convertItemToItemN2G = (items: any) => {
        return items?.map((x: any) => {
            return {
                sku: x.item?.sku,
                quantity: x.orderCount || x.quantityOrdered || 0
            }
        });
    };

    const getLocationAndConvertLocationN2G = async (locationId: string) => {
        const {NODE_ENV} = process.env;
        if (locationId) {
            const res = await getLocationById(locationId);
            const location = res?.data;
            return {
                name: NODE_ENV === "production" ? `${location?.organization?.name} ${location?.clubCode}` : `[TEST] ${location?.organization?.name} ${location?.clubCode}`,
                clubCode: location?.clubCode,
                address: location?.streetAddress1,
                address2: location?.streetAddress2,
                city: location?.city,
                state: location?.state,
                zip: location?.zipCode,
                country: "United States"
            }
        }
    };

    const getCustomerN2G = () => {
        return {
            name: targetPurchaseOrder?.requestedUser ? `${targetPurchaseOrder.requestedUser?.firstName} ${targetPurchaseOrder.requestedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`,
            email: targetPurchaseOrder?.requestedUser ? targetPurchaseOrder.requestedUser?.emailAddress : userInfo.emailAddress
        }
    }

    const getCustomerN2GWhenLoading = (targetPo: any) => {
        return {
            name: targetPo?.requestedUser ? `${targetPo.requestedUser?.firstName} ${targetPo.requestedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`,
            email: targetPo?.requestedUser ? targetPo.requestedUser?.emailAddress : userInfo.emailAddress
        }
    }

    const buildErrorMessageN2G = (errors: any) => {

        let message = '';
        for (let index = 0; index < errors.length; index++) {
            const element = errors[index];
            if (message === '') {
                message = element?.message;
            } else {
                message += `, ${element.message}`;
            }
        }
        ;

        return message;
    };

    const getErrorItemN2G = (sku: string) => {
        let message = '';
        const errorItemBySku = errorsN2G?.items?.find((i: any) => i.sku === sku);
        if (errorItemBySku) {
            message = errorItemBySku.quantityAvailable !== undefined ? t('orderPage.itemN2GOutOfStock').replace('%quantity%', errorItemBySku.quantityAvailable) : errorItemBySku.message;
        }

        return message;
    }

    const customFilterOption = (option: any, inputValue: any) => {
        const label = option.label?.toLowerCase();
        const upc = option.value?.upcs?.find((x: any) => x?.upcCode?.includes(inputValue))?.upcCode?.toLowerCase();
        const input = inputValue.toLowerCase();
    
        return label?.includes(input) || upc?.includes(input);
    };

    //remove inactive item
    const removeInActiveItem = () => {
        setData(
            data.filter((entry: any) => entry.item?.isActive === true)
        );
    };
    // Generic function to remove items by a property
    const removeItemsBy = (property: string, valuesToRemove: any) => {
        const removeInactiveData = data.filter((entry: any) => entry.item?.isActive === true);
        setData(
            removeInactiveData.filter((entry) => {
            // Handle nested properties (e.g., item.id, item.sku)
            const value = property.includes('.')
            ? property.split('.').reduce((obj: any, key: any) => obj[key], entry)
            : entry[property];
            return !valuesToRemove.includes(value);
        })
        );
    };

    return (
        <>
            <div className="flex flex-col w-full">
                <div className="flex relative xl:flex-row gap-4 flex-col w-full p-[15px] border-b border-gray-200 justify-between">
                    <ButtonBack buttonName={t('sidebar.purchaseOrder')}/>
                    <div className="text-primary text-lg font-semibold flex items-center">
                        <div className="text-lg">
                                <span className="gr">
                                    <span className="font-normal">
                                        {t('orderPage.orderId').toUpperCase()}: &nbsp;
                                    </span>
                                    <span>{targetPurchaseOrder.orderN2GId ? targetPurchaseOrder.orderN2GId : targetPurchaseOrder.id}&nbsp;</span>
                                    <span className="font-normal">({new Intl.NumberFormat('en-US').format(
                                        totalItem,
                                    )} items)</span>&nbsp;| &nbsp;
                                </span>
                                <span className="gr">
                                    <span className="font-normal">
                                        {t('orderPage.total').toUpperCase()}:
                                    </span>
                                    <span>{formatMoney(orderTotal || 0)}</span>
                                </span>
                            </div>
                    </div>
                    <div className="flex md:gap-4 gap-2">
                        {targetPurchaseOrder.status === 'Requested'
                            ?
                            (
                                <>
                                    <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                        text={t('orderPage.duplicated')}/>
                                    <Buttons className="text-white bg-secondary"
                                             onClick={() => handleUpdatePurchaseOrder(data, 'Rejected')}
                                             text={t('orderPage.reject')}/>
                                    <Buttons
                                        className="text-white bg-primary"
                                        onClick={() => isLoading ? {} : handleUpdatePurchaseOrder(data, 'Ordered')}
                                        text={t('orderPage.approved')}
                                    />
                                    <Buttons className="text-white bg-red-500 w-[172px]" onClick={() => handleRemoveAllInvalid()}
                                                 text={t('orderPage.removeAllInvalid')}/>
                                </>
                            )
                            :
                            targetPurchaseOrder.status === 'Rejected'
                                ?
                                (
                                    <>
                                        <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                        text={t('orderPage.duplicated')}/>
                                        <div
                                            className="bg-red-50 border border-dashed border-red-300 p-[10px] rounded-[2px]">
                                            <Status type={targetPurchaseOrder?.status}/>
                                        </div>
                                    </>
                                )
                                :
                                targetPurchaseOrder.status === 'Ordered'
                                    ?
                                    (
                                        <>
                                            <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                        text={t('orderPage.duplicated')}/>
                                            <div
                                                className="bg-blue-50 border border-dashed border-blue-300 p-[10px] rounded-[2px]">
                                                <Status type={targetPurchaseOrder?.status}/>
                                            </div>
                                        </>
                                    )
                                    :
                                    targetPurchaseOrder.status === 'Received'
                                        ?
                                        (
                                            <>
                                                <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                    text={t('orderPage.duplicated')}/>
                                                <div
                                                className="bg-green-50 border border-dashed border-green-300 p-[10px] rounded-[2px]">
                                                    <Status type={targetPurchaseOrder?.status}/>
                                                </div>
                                            </>

                                        )
                                        :
                                        targetPurchaseOrder.status === 'Partially Received'
                                        ?
                                        (
                                            <>
                                                <Buttons className="text-white bg-yellow-500" onClick={() => isLoading ? {} : handleDuplicatePO(targetPurchaseOrder)}
                                                    text={t('orderPage.duplicated')}/>
                                                <div
                                                    className="bg-gray-50 border border-dashed border-purple-300 p-[10px] rounded-[2px]">
                                                    <Status type={targetPurchaseOrder?.status}/>
                                                </div>
                                            </>

                                        )
                                        :
                                        (
                                            <>
                                                <Buttons className="text-white bg-red-500 w-[172px]" onClick={() => handleRemoveAllInvalid()}
                                                            text={t('orderPage.removeAllInvalid')}/>
                                                <div
                                                    className="bg-gray-50 border border-dashed border-gray-300 px-[12px] py-[5px] rounded-[2px]">
                                                    <Status type={targetPurchaseOrder?.status}/>
                                                </div>
                                            </>
                                        )
                        }
                    </div>
                </div>
                <div
                    className="status3column bg-gray-50 shadow-sm border-b bg-gray-50">
                    <div className="column1">
                        {targetPurchaseOrder.status !== 'Draft' && (<ReviewBy label="Requested On"
                                                                              content={formatDateWithTime(targetPurchaseOrder.requestedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status !== 'Draft' && (
                            <ReviewBy label="Requested By" className="font-medium"
                                      content={targetPurchaseOrder.requestedUser?.firstName !== undefined ? `${targetPurchaseOrder.requestedUser?.firstName} ${targetPurchaseOrder.requestedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`}/>)}
                    </div>
                    <div className="column2">
                        {(targetPurchaseOrder.status !== 'Requested' && targetPurchaseOrder.status !== 'Draft' && targetPurchaseOrder.status !== 'Rejected') && (<ReviewBy label="Ordered On"
                                                                                    content={formatDateWithTime(targetPurchaseOrder.orderedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status !== 'Draft' && (
                            <ReviewBy label="Reviewed By" className="font-medium"
                                      content={targetPurchaseOrder.reviewedUser?.firstName !== undefined ? `${targetPurchaseOrder.reviewedUser?.firstName} ${targetPurchaseOrder.reviewedUser?.lastName}` : `${userInfo.firstName} ${userInfo.lastName}`}/>)}
                    </div>
                    <div className="column3">
                        {targetPurchaseOrder.status === 'Received' && (<ReviewBy label="Received On"
                                                                                 content={formatDateWithTime(targetPurchaseOrder.receivedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status === 'Rejected' && (<ReviewBy label="Rejected On"
                                                                                 content={formatDateWithTime(targetPurchaseOrder.rejectedOn?.toString() || '')}/>)}
                        {targetPurchaseOrder.status === 'Received' && (
                            <ReviewBy label="Received By" className="font-medium"
                                      content={`${targetPurchaseOrder.receivedUser?.firstName} ${targetPurchaseOrder.receivedUser?.lastName}`}/>)}
                    </div>
                </div>
                <div className="purchase-order-detail overflow-x-auto" id="purchase-order-review-custom-portal">
                    {data && data.length === 0 ? (
                        <EmptyState
                            buttonName="Add Item"
                            handleAddClick={isWriteOrg && handleAddRow}
                            title={t('stockPage.titleNoItemResult')}
                            subtitle={t('itemPage.subTitleNoResult')}
                            icon={itemEmpty}
                        />
                    ) : (
                        <>
                            <Table>
                                <Table.Head className="text-gray-900 border-b border-gray-100 border-b-2 w-full">
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs item px-0 pr-3 py-2"
                                        onClick={() => handleHeaderSort('itemName')}>
                                            <div className="flex items-center ">
                                                {t('itemPage.item')}
                                                <Sort check={sortBy === 'itemName'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs upc px-3 py-0"
                                        onClick={() => handleHeaderSort('itemSku')}>
                                            <div className="flex items-center ">
                                                {t('itemPage.sku').toUpperCase()}
                                                <Sort check={sortBy === 'itemSku'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('stockPage.count').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.unitSoldLast7').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.6weekavg').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs cases px-3 py-0"
                                        onClick={() => handleHeaderSort('quantityOrdered')}>
                                            <div className="flex items-center ">
                                                {t('orderPage.cases').toUpperCase()}
                                                <Sort check={sortBy === 'quantityOrdered'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.received').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs cost-pc px-3 py-0"
                                        onClick={() => handleHeaderSort('itemCaseCost')}>
                                            <div className="flex items-center ">
                                                {t('orderPage.costPerCase').toLocaleUpperCase()}
                                                <Sort check={sortBy === 'itemCaseCost'} sortByType={sortByType}/>
                                            </div>
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs unit-pc px-3 py-0">
                                        {t('orderPage.unitPerCase').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs total px-3 py-0">
                                        {t('orderPage.totalUnit').toLocaleUpperCase()}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs order px-3 py-0">
                                        {t('orderPage.totalOrder')}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs order px-3 py-0">
                                        {`Requested On`}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="cursor-pointer bg-white font-medium text-xs order px-3 py-0">
                                        {`Ordered On`}
                                    </Table.HeadCell>
                                    <Table.HeadCell
                                        className="sticky right-0 bg-white font-medium text-xs action px-3 py-0 shadow-lg z-10">{''}
                                    </Table.HeadCell>
                                </Table.Head>
                                <Table.Body
                                    // className={cn('', {
                                    //   '--overflow': data?.length > 6,
                                    // })}
                                >
                                    {data.map((item: purchaseOrderItemType, index) => {
                                        return (
                                            <Table.Row key={`row-${item.id}`}
                                                       className="cursor-pointer bg-white text-sm hover:bg-gray-50 border-b border-gray-100">
                                                {item.itemId === '' ?
                                                    (
                                                        <Table.Cell className="px-0 pr-3 py-3 item">
                                                            <MultiSelect
                                                                onChange={(e: any) => {
                                                                    handleChangeItem(item?.id, e, 'itemId');
                                                                }}
                                                                options={itemTypeOptions}
                                                                value={itemTypeOptions.find((i: any) => i.value?.id === item.itemId)}
                                                                id={`item-${index}`}
                                                                name={`item-${index}`}
                                                                noOptionsMessage={() => t('No options')}
                                                                closeMenuOnSelect
                                                                isHolderLabel={false}
                                                                isDisabled={
                                                                    targetPurchaseOrder.status === 'Ordered' ||
                                                                    targetPurchaseOrder.status === 'Rejected' ||
                                                                    targetPurchaseOrder.status === 'Received'
                                                                        ? true
                                                                        : false
                                                                }
                                                                filterOption={customFilterOption}
                                                                dropdownRoot={document.getElementById('purchase-order-review-custom-portal')}
                                                            />
                                                            <div
                                                                className={`text-red-600 text-xs font-normal mt-1 warning`}>{t('userManagementPage.requiredField')}</div>
                                                        </Table.Cell>
                                                    )
                                                    :
                                                    (
                                                        <Tooltip
                                                        content={itemTypeOptions.find((i: any) => i.value?.id === item.itemId) ? itemTypeOptions.find((i: any) => i.value?.id === item.itemId)?.label : ""}>
                                                            <Table.Cell className="px-0 pr-3 py-3 item">
                                                                <MultiSelect
                                                                    onChange={(e: any) => {
                                                                        handleChangeItem(item?.id, e, 'itemId');
                                                                    }}
                                                                    options={itemTypeOptions}
                                                                    value={itemTypeOptions.find((i: any) => i.value?.id === item.itemId)}
                                                                    id={`item-${index}`}
                                                                    name={`item-${index}`}
                                                                    noOptionsMessage={() => t('No options')}
                                                                    closeMenuOnSelect
                                                                    isHolderLabel={false}
                                                                    isDisabled={
                                                                        targetPurchaseOrder.status === 'Ordered' ||
                                                                        targetPurchaseOrder.status === 'Rejected' ||
                                                                        targetPurchaseOrder.status === 'Received'
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    filterOption={customFilterOption}
                                                                    dropdownRoot={document.getElementById('purchase-order-review-custom-portal')}
                                                                />
                                                                {item.item?.isActive === false && (
                                                                    <div className={`text-red-600 text-xs font-normal mt-1 warning`}>{t('itemPage.inactiveItem')}
                                                                    </div>
                                                                )}
                                                            </Table.Cell>
                                                        </Tooltip>
                                                    )
                                                }
                                                <Table.Cell className="px-3 py-3 upc">
                                                    <Label>{item?.item?.sku}</Label>
                                                    {getErrorItemN2G(item?.item?.sku) !== ''
                                                        ?
                                                        (<div
                                                            className={`text-red-600 text-xs font-normal mt-1 warning`}>{getErrorItemN2G(item?.item?.sku)}</div>)
                                                        :
                                                        ('')
                                                    }
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.quantityOnHand || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.unitSoldLast7 || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 avg-week">
                                                    <Label>{item?.sixWeekAvg || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 cases">
                                                    <TextInput
                                                        type="number"
                                                        min={1}
                                                        max={item?.item?.maxOrderQuantity || undefined}
                                                        className="custom-input-count"
                                                        id={`orderCount-${index}`}
                                                        name={`orderCount-${index}`}
                                                        value={item?.orderCount}
                                                        onChange={(e: any) => {
                                                            handleChangeContentOverview(item?.id, e.target.value, 'orderCount');
                                                        }}
                                                        disabled={
                                                            targetPurchaseOrder.status === 'Ordered' ||
                                                            targetPurchaseOrder.status === 'Rejected' ||
                                                            targetPurchaseOrder.status === 'Received'
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {item.orderCount === 0 ? (
                                                        <div
                                                            className={`text-red-600 text-xs font-normal mt-1 warning`}>
                                                            {t('userManagementPage.requiredField')}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                    {item.item?.maxOrderQuantity && (item.orderCount || 0) > item.item?.maxOrderQuantity ? (
                                                        <div
                                                            className={`text-red-600 text-xs font-normal mt-1 warning`}>
                                                            Max Order: {item.item?.maxOrderQuantity}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.quantityReceived || 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 cost-pc">
                                                    <Label>{formatMoney(item?.item?.caseCost)}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 unit-pc">
                                                    <Label>{item?.item?.upcs?.find((x: any) => x.default === true)?.caseQuantity}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 total">
                                                    <Label>{item?.orderCount ? item?.orderCount * item?.item?.upcs?.find((x: any) => x.default === true)?.caseQuantity : 0}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 order">
                                                    <Label>{formatMoney((item?.orderCount || 0) * (item?.item?.caseCost))}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 order">
                                                    <Label>{formatDateWithTime(targetPurchaseOrder.requestedOn?.toString() || '')}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="px-3 py-3 order">
                                                    <Label>{formatDateWithTime(targetPurchaseOrder.orderedOn?.toString() || '')}</Label>
                                                </Table.Cell>
                                                <Table.Cell className="sticky right-0 bg-white px-3 py-3 action shadow-lg z-10">
                                                    <GroupButtonWithIcons
                                                        className="items-center justify-center"
                                                        buttons={[
                                                            {
                                                                type: 'button',
                                                                text: '',
                                                                classType: 'white',
                                                                icon: <HiOutlineTrash size={'20px'}/>,
                                                                disabled:
                                                                    targetPurchaseOrder.status === 'Ordered' ||
                                                                    targetPurchaseOrder.status === 'Rejected' ||
                                                                    targetPurchaseOrder.status === 'Received'
                                                                        ? true
                                                                        : false,
                                                                action: () => {
                                                                    handleDeleteRow(item?.id, item?.item?.sku);
                                                                },
                                                            },
                                                            {
                                                                type: 'button',
                                                                text: '',
                                                                classType: 'white',
                                                                icon: <HiOutlineExclamationCircle size={'20px'}/>,
                                                                action: () => {
                                                                    handleStatictisItem(item?.item?.id, item?.item?.name);
                                                                },
                                                            },
                                                        ]}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>
                            {isLoading && <SpinnerComponent/>}
                            {targetPurchaseOrder.status === 'Requested' || targetPurchaseOrder.status === 'Draft' ? (
                                    <div className="group-button-footer">
                                        <div className="left">
                                            <Buttons className="text-secondary border border-secondary"
                                                     onClick={() => addRowFunc()} text={t('orderPage.addSingleItem')}
                                            />
                                            <Buttons
                                                className="text-secondary border border-secondary"
                                                onClick={() => handleAddItemByCategory()}
                                                text={t('orderPage.addItemBycategory')}
                                            />
                                        </div>
                                        <div
                                            className="right">
                                            <Buttons className="text-white bg-gray-400"
                                                 onClick={() => isSaveDraft ? {} : handleSaveDraft(data)}
                                                 text={t('orderPage.saveDraft')}/>
                                            <Buttons className="text-white bg-primary"
                                                     onClick={() => isLoading ? {} : handleUpdatePurchaseOrder(data, 'Requested')}
                                                     text={t('orderPage.saveReview')}/>
                                        </div>
                                    </div>
                                )
                                :
                                ''
                            }
                        </>
                    )}
                </div>
            </div>
            {openModal && (
                <CreateItemByCategoryModal
                    headerTitle={t('categoryPage.chooseCategory')}
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    category={category}
                    setCategory={setCategory}
                    queryClient={queryClient}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
            {openModalStatistics && (
                <StatisticsSaleModal
                    headerTitle={t('stockPage.statisticsSale')}
                    openModal={openModalStatistics}
                    setOpenModal={setOpenModalStatistics}
                    itemName={itemNameChart}
                    data={dataChart}
                />
            )}
            {openMlvedaErrorModal && (
                <MlvedaErrorModal
                    headerTitle={t('orderPage.errorN2gHeader')}
                    openModal={openMlvedaErrorModal}
                    setOpenModal={setOpenMlvedaErrorModal}
                    data={mlvedaError}
                    queryClient={queryClient}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                />
            )}
        </>
    );
};

export default PurchaseOrderReview;
